import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import DismissableModal from "components/DismissableModal";
import { showNotification } from "services/NotificationService";
import EventNoteRecorder from "./EventNoteRecorder";
import {
  dispatchEvent as dispatchEventAction,
  resetEventExecutorStatus as resetEventExecutorStatusAction,
} from "./SwitchStateChanger.actions";

const EventDispatcher = ({
  event,
  wfItemId,
  onEventExecuted,
  modalOpenerProps,
  eventExecuterProps,
  modalProps,
  switchState,
}) => {
  const [notes, setNotes] = useState("");
  const modalRef = useRef(null);

  const eventExecutorStatus = useSelector(
    (state) => state.switchDetails.eventExecutorStatus
  );
  const eventInExecution = useSelector(
    (state) => state.switchDetails.eventInExecution
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (event === eventInExecution) {
      if (eventExecutorStatus === "success") {
        showNotification({
          title: "Successfully Executed Event!",
          message: `The event: ${event} has been executed successfully.`,
          position: "bl",
          type: "success",
        });
        dispatch(resetEventExecutorStatusAction());
        onEventExecuted();
        if (modalRef.current) {
          modalRef.current.handleClose();
        }
      }
      if (eventExecutorStatus === "failure") {
        showNotification({
          title: "Event Execution Failed!",
          message: `Failed to execute event: ${event}.`,
          position: "bl",
          type: "error",
        });
        dispatch(resetEventExecutorStatusAction());
      }
    }
  }, [eventExecutorStatus, eventInExecution, event, onEventExecuted, dispatch]);

  const handleDispatchEvent = () => {
    dispatch(dispatchEventAction(event, wfItemId, notes));
  };

  const modalOpener = (
    <Button
      key={1}
      onClick={() => modalRef.current.handleShow()}
      variant={modalOpenerProps.variant}
      size={modalOpenerProps.size}
      block={modalOpenerProps.block}
      disabled={
        (switchState && switchState === "CLOSED") || modalOpenerProps.disabled
      }
      className={modalOpenerProps.className}
    >
      {modalOpenerProps.children}
    </Button>
  );

  const customFooterContent = (
    <div>
      <Button
        variant="outline-dark"
        onClick={() => modalRef.current.handleClose()}
      >
        Cancel
      </Button>
      <Button
        disabled={eventExecutorStatus === "requested" && event === eventInExecution}
        className="left-spacer"
        variant={eventExecuterProps.variant}
        onClick={handleDispatchEvent}
      >
        {eventExecutorStatus === "requested" && event === eventInExecution
          ? "Executing ..."
          : eventExecuterProps.children}
      </Button>
    </div>
  );

  return (
    <DismissableModal
      ref={modalRef}
      openModalButton={modalOpener}
      openModalButtonClassName="btn-block"
      customFooterContent={customFooterContent}
      title={modalProps.title}
      centered
    >
      <div>
        {modalProps.children}
        <EventNoteRecorder handleChange={(notes) => setNotes(notes)} />
      </div>
    </DismissableModal>
  );
};

export default EventDispatcher;